module.exports = __webpack_public_path__ + "img/lily.be5030ca.webp";